import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ContactItemComponent } from './components/contact-item/contact-item.component';
import { ContactSelectorItemComponent } from './components/contact-selector-item/contact-selector-item.component';

const components: Type<any>[] = [
	ContactItemComponent,
	ContactSelectorItemComponent
];

@NgModule({
	declarations: components,
	imports: [
		IonicModule,
		CommonModule
	],
	exports: components
})
export class ContactsModule { }